<template>
  <svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <symbol id="searchPlus" viewBox="0 0 32 32"><path d="M19.988 12.75v0.5c0 0.412-0.337 0.75-0.75 0.75h-5.25v5.25c0 0.413-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.337-0.75-0.75v-5.25h-5.25c-0.412 0-0.75-0.338-0.75-0.75v-0.5c0-0.412 0.338-0.75 0.75-0.75h5.25v-5.25c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v5.25h5.25c0.413 0 0.75 0.338 0.75 0.75zM31.769 31.063l-0.706 0.706c-0.294 0.294-0.769 0.294-1.063 0l-8.063-8.063c-0.144-0.144-0.219-0.331-0.219-0.531v-0.531c-2.306 2.087-5.363 3.356-8.719 3.356-7.138 0-12.906-5.694-13-12.831-0.094-7.313 5.856-13.262 13.169-13.169 7.137 0.094 12.831 5.862 12.831 13 0 3.356-1.269 6.413-3.356 8.719h0.531c0.2 0 0.387 0.081 0.531 0.219l8.063 8.063c0.294 0.294 0.294 0.769 0 1.063zM24 13c0-6.081-4.919-11-11-11s-11 4.919-11 11 4.919 11 11 11 11-4.919 11-11z"></path></symbol>

  <symbol id="mouseScroll" viewBox="0 0 12 32"><path d="M6.238 31.454l2.736-2.778c0.111-0.111 0.111-0.29 0-0.401l-0.167-0.167c-0.111-0.111-0.29-0.111-0.401 0l-2.368 2.41-2.368-2.413c-0.111-0.111-0.29-0.111-0.401 0l-0.167 0.167c-0.111 0.111-0.111 0.29 0 0.401l2.736 2.778c0.111 0.111 0.29 0.111 0.401 0.002z"></path><path d="M6.038 6.286c-3.335 0-6.038 2.703-6.038 6.038v7.245c0 3.335 2.703 6.038 6.038 6.038s6.038-2.703 6.038-6.038v-7.245c0-3.335-2.703-6.038-6.038-6.038zM6.038 7.494c2.668 0 4.83 2.163 4.83 4.83v7.245c0 2.668-2.163 4.83-4.83 4.83s-4.83-2.163-4.83-4.83v-7.245c0-2.668 2.163-4.83 4.83-4.83z"></path><path d="M6.038 12.214c0.667 0 1.208 0.541 1.208 1.208v2.415c0 0.667-0.541 1.208-1.208 1.208s-1.208-0.541-1.208-1.208v-2.415c0-0.667 0.541-1.208 1.208-1.208z"></path><path d="M8.807 3.788l0.167-0.167c0.111-0.111 0.111-0.29 0-0.401l-2.736-2.778c-0.111-0.111-0.29-0.111-0.401-0.002l-2.736 2.778c-0.111 0.111-0.111 0.29 0 0.401l0.167 0.167c0.111 0.111 0.29 0.111 0.401 0l2.368-2.41 2.368 2.413c0.111 0.111 0.29 0.111 0.401 0z"></path></symbol>

    <symbol id="loading" viewBox="0 0 57 57" stroke="#777">
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
          <circle cx="5" cy="50" r="5">
            <animate attributeName="cy"
              begin="0s" dur="2.2s"
              values="50;5;50;50"
              calcMode="linear"
              repeatCount="indefinite" />
            <animate attributeName="cx"
              begin="0s" dur="2.2s"
              values="5;27;49;5"
              calcMode="linear"
              repeatCount="indefinite" />
          </circle>
          <circle cx="27" cy="5" r="5">
            <animate attributeName="cy"
              begin="0s" dur="2.2s"
              from="5" to="5"
              values="5;50;50;5"
              calcMode="linear"
              repeatCount="indefinite" />
            <animate attributeName="cx"
              begin="0s" dur="2.2s"
              from="27" to="27"
              values="27;49;5;27"
              calcMode="linear"
              repeatCount="indefinite" />
          </circle>
          <circle cx="49" cy="50" r="5">
            <animate attributeName="cy"
              begin="0s" dur="2.2s"
              values="50;50;5;50"
              calcMode="linear"
              repeatCount="indefinite" />
            <animate attributeName="cx"
              from="49" to="49"
              begin="0s" dur="2.2s"
              values="49;5;27;49"
              calcMode="linear"
              repeatCount="indefinite" />
          </circle>
        </g>
      </g>
    </symbol>
  </defs>
</svg>
</template>

<script>
export default {
  name: 'SvgDefs'
}
</script>